export default __webpack_public_path__ + "static/media/6.968e5eef.PNG";